<template>
  <v-container>
    <v-layout row wrap>
    </v-layout>
       <iframe id="pdf" target="_blank" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%"> </iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapActions } from "vuex";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import DocumentService from "@/services/DocumentService";
import fontkit from "@pdf-lib/fontkit";
import SettingService from "@/services/SettingService";
import { async } from 'q';
export default {
    data(){
     return {
      companybuilding: "", //อาคาร
      companyroom_no:"", //ห้อง
      companyfloor:"", //ชั้น
      companyvillage:"",//หมู่บ้าน
      companyhouse_no:"",//บ้านเลขที่
      companyvillage_no:"",//หมู่ที่
      companyalley_lane:"",//ตรอก/ซอย
      companyroad:"",//ถนน
      companysubdistrict_subarea:"", //ตำบล/แขวง
      companydistrict_area:"",//อำเภอ/เขต
      companyprovince: "",//จังหวัด
      companypostcode: "",//รหัสไปรษณีย์
      companyName: "",
      taxpayer_number:"",
      year:"",
      emps:0,
      totalDeductTax:"",
      totalEarning:""

  }
  },
 async created() {
      this.year = this.$route.params.year;
      this.branch = this.$route.params.branch;
      this.department = this.$route.params.department;
    await this.getData();
    await this.pdf();
  },

  methods: {
     groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
     async getData() {
       let v = this;
        let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
          try {
        let WHTkor = await DocumentService.getTaxDetailByYearAllEmp(this.year,branchs,this.department );
           var total_person = this.groupBy(WHTkor.data.details, "emp_code");
            for (var key in total_person) {
              this.emps += 1;
            }
          this.totalDeductTax = WHTkor.data.total_tax;
          this.totalEarning = WHTkor.data.total_earning;
      } catch (err) {
        console.log(err);
      }
      }else{
        branchs = this.branch;
          try {
        let WHTkor = await DocumentService.getTaxDetailByYear(this.year,branchs,this.department );
           var total_person = this.groupBy(WHTkor.data.details, "emp_code");
            for (var key in total_person) {
              this.emps += 1;
            }
          this.totalDeductTax = WHTkor.data.total_tax;
          this.totalEarning = WHTkor.data.total_earning;
      } catch (err) {
        console.log(err);
      }
      }
    
    },
        async pdf() {
        const url = '/static/pdf/210360_WHT1_kor.pdf'
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
        pdfDoc.registerFontkit(fontkit)
        const urlfont = '/static/Sarabun-Regular.ttf'
        const fontBytes = await fetch(urlfont).then(res => res.arrayBuffer())
        const customFont = await pdfDoc.embedFont(fontBytes)
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const { width, height } = firstPage.getSize();
        
        const tmpResult = await SettingService.getDataCompany();
          this.companyName = tmpResult.data.content[0].companyname;
          this.companybuilding = tmpResult.data.content[0].building; //อาคาร
          this.companyroom_no = tmpResult.data.content[0].room_no; //ห้อง
          this.companyfloor = tmpResult.data.content[0].floor; //ชั้น
          this.companyvillage = tmpResult.data.content[0].village;//หมู่บ้าน
          this.companyhouse_no = tmpResult.data.content[0].house_no;//บ้านเลขที่
          this.companyvillage_no = tmpResult.data.content[0].village_no;//หมู่ที่
          this.companyalley_lane = tmpResult.data.content[0].alley_lane;//ตรอก/ซอย
          this.companyroad = tmpResult.data.content[0].road;//ถนน
          this.companysubdistrict_subarea = tmpResult.data.content[0].subdistrict_subarea; //ตำบล/แขวง
          this.companydistrict_area = tmpResult.data.content[0].district_area;//อำเภอ/เขต
          this.companyprovince = tmpResult.data.content[0].province;//จังหวัด
          this.companypostcode = tmpResult.data.content[0].postcode;//รหัสไปรษณีย์
          this.taxpayer_number = tmpResult.data.content[0].taxpayer_number;
          
                 //เล่มที่
        // firstPage.drawText("001", {
        //   x: 530,
        //   y: 783 ,
        //   size: 10,
        //   font: customFont,
        //   color: rgb(0, 0, 0),
        // });
        //เลขที่
        // firstPage.drawText("001", {
        //   x: 530,
        //   y: 768 ,
        //   size: 10,
        //   font: customFont,
        //   color: rgb(0, 0, 0),
        // });

         //เลขประจำตัวผู้เสียภาษีอาการ(13 หลัก)
         if(this.taxpayer_number != null){
            firstPage.drawText(""+this.taxpayer_number.substring(0,1), { x: 169,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(1,2), { x: 185,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(2,3), { x: 196,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(3,4), { x: 206,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(4,5), { x: 217,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(5,6), { x: 233,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(6,7), { x: 244,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(7,8), { x: 254,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(8,9), { x: 265,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(9,10), { x: 276,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(10,11), { x: 293,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(11,12), { x: 303,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
            firstPage.drawText(""+this.taxpayer_number.substring(12,13), { x: 319,y: 720 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
         }
        //ประจำปีภาษี
           firstPage.drawText(""+this.year, { x: 510, y: 700 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        //ชื่อบริษัท
         if(this.companyName==''|| this.companyName==null){
           firstPage.drawText("-", { x: 60, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
         }else{
          firstPage.drawText(""+this.companyName, { x: 60, y: 675 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
         }
        //อาคาร
        if(this.companybuilding==''|| this.companybuilding==null){
          firstPage.drawText("-", {x: 130, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companybuilding, {x: 120, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         //ห้องที่
        if(this.companyroom_no ==''|| this.companyroom_no==null){
          firstPage.drawText("-", {x: 200, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyroom_no, {x: 200, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         //ชั้นที่
        if(this.companyfloor ==''|| this.companyfloor==null){
          firstPage.drawText("-", {x: 235, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyfloor, {x: 235, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }

         //หมู่บ้าน
        if(this.companyvillage ==''|| this.companyvillage==null){
          firstPage.drawText("-", {x: 285, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyvillage, {x: 275, y: 660 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
        
         //ที่อยู่
         if(this.companyhouse_no ==''|| this.companyhouse_no==null){
           firstPage.drawText("-", {x: 80,y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
         }
         else{
           firstPage.drawText(""+this.companyhouse_no, {x: 80,y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
         }
       
       //หมู่ที่
        if(this.companyvillage_no ==''|| this.companyvillage_no==null){
          firstPage.drawText("-", {x: 165, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyvillage_no, {x: 165, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }

         //ตรอก/ซอย
        if(this.companyalley_lane ==''|| this.companyalley_lane==null){
          firstPage.drawText("-", {x: 230, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyalley_lane, {x: 230, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         firstPage.drawText("-", {x: 310, y: 645 ,size: 10,font: customFont,color: rgb(0, 0, 0),});

        //ถนน
        if(this.companyroad ==''|| this.companyroad== null){
          firstPage.drawText("-", {x: 80, y: 630 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companyroad, {x: 80, y: 630 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
        //ตำบล
        if(this.companysubdistrict_subarea ==''|| this.companysubdistrict_subarea== null){
          firstPage.drawText("-", {x: 250,y: 630 , size: 10,font: customFont,color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companysubdistrict_subarea, {x: 250,y: 630 , size: 10,font: customFont,color: rgb(0, 0, 0),});
        }
         //อำเภอ
        if(this.companydistrict_area ==''|| this.companydistrict_area== null){
          firstPage.drawText("-", {x: 120, y: 615 ,size: 10,font: customFont, color: rgb(0, 0, 0),});
        }else{
          firstPage.drawText(""+this.companydistrict_area, {x: 120, y: 615 ,size: 10,font: customFont, color: rgb(0, 0, 0),});
        }
        //เชียงใหม่
        if(this.companyprovince ==''|| this.companyprovince== null){
          firstPage.drawText("-", { x: 250, y: 615 , size: 10, font: customFont,color: rgb(0, 0, 0),});
        }
        else{
          firstPage.drawText(""+this.companyprovince, { x: 250, y: 615 , size: 10, font: customFont,color: rgb(0, 0, 0),});
        }
         //รหัสไปรษณีย์
        firstPage.drawText(""+this.companypostcode.substring(0,1), { x: 107,y: 600 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(1,2), { x: 118,y: 600 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(2,3), { x: 129,y: 600 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(3,4), { x: 139,y: 600 ,size: 10,font: customFont,color: rgb(0, 0, 0),});
        firstPage.drawText(""+this.companypostcode.substring(4,5), { x: 149,y: 600 ,size: 10,font: customFont,color: rgb(0, 0, 0),});

       //จำนวนผู้เสียภาษี
        firstPage.drawText("" + this.emps, {
        x: 336,
        y: 395,
        size: 10,
        font: customFont,
        color: rgb(0, 0, 0)
      });
      
       //จำนวน เงินทั้งสิ้น
       let totalEarning = this.thousandSep(this.totalEarning).split(".");
      if(totalEarning[0].length >= 13){
         firstPage.drawText(""+  totalEarning[0], { x:(431-(5 * (totalEarning[0].length - 4) )) - totalEarning[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalEarning[0].length < 13 && totalEarning[0].length >= 9){
         firstPage.drawText(""+  totalEarning[0], { x:(431-(5 * (totalEarning[0].length - 3) )) - totalEarning[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalEarning[0].length < 9 && totalEarning[0].length >= 4){
          firstPage.drawText(""+  totalEarning[0], { x:(431-(5 * (totalEarning[0].length - 2) )) - totalEarning[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalEarning[0], { x:(431-(5 * (totalEarning[0].length - 1) )) - totalEarning[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalEarning[1],{ x: 436 ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
        
       //จำนวนภาษีทั้งสิ้น
        let totaldeduct_tax = this.thousandSep(this.totalDeductTax).split(".");
      if(totaldeduct_tax[0].length >= 13){
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(521-(5 * (totaldeduct_tax[0].length - 4) )) - totaldeduct_tax[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totaldeduct_tax[0].length < 13 && totaldeduct_tax[0].length >= 9){
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(521-(5 * (totaldeduct_tax[0].length - 3) )) - totaldeduct_tax[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totaldeduct_tax[0].length < 9 && totaldeduct_tax[0].length >= 4){
          firstPage.drawText(""+  totaldeduct_tax[0], { x:(521-(5 * (totaldeduct_tax[0].length - 2) )) - totaldeduct_tax[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      
      }
      else{
         firstPage.drawText(""+  totaldeduct_tax[0], { x:(521-(5 * (totaldeduct_tax[0].length - 1) )) - totaldeduct_tax[0].length ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totaldeduct_tax[1],{ x: 526 ,y: 395,size: 10,font: customFont, color: rgb(0, 0, 0)}); 



        let totalsumEarning = this.thousandSep(this.totalEarning).split(".");
      if(totalEarning[0].length >= 13){
         firstPage.drawText(""+  totalsumEarning[0], { x:(431-(5 * (totalsumEarning[0].length - 4) )) - totalsumEarning[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumEarning[0].length < 13 && totalEarning[0].length >= 9){
         firstPage.drawText(""+  totalsumEarning[0], { x:(431-(5 * (totalsumEarning[0].length - 3) )) - totalsumEarning[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumEarning[0].length < 9 && totalsumEarning[0].length >= 4){
          firstPage.drawText(""+  totalsumEarning[0], { x:(431-(5 * (totalsumEarning[0].length - 2) )) - totalsumEarning[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalsumEarning[0], { x:(431-(5 * (totalsumEarning[0].length - 1) )) - totalsumEarning[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalsumEarning[1],{ x: 436 ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)}); 
        

        //จำนวนผู้เสียภาษี
        firstPage.drawText("" + this.emps, {
        x: 336,
        y: 259,
        size: 10,
        font: customFont,
        color: rgb(0, 0, 0)
      });

       //จำนวนรวมภาษีทั้งสิ้น
        let totalsumdeduct_tax = this.thousandSep(this.totalDeductTax).split(".");
      if(totalsumdeduct_tax[0].length >= 13){
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(521-(5 * (totalsumdeduct_tax[0].length - 4) )) - totalsumdeduct_tax[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumdeduct_tax[0].length < 13 && totalsumdeduct_tax[0].length >= 9){
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(521-(5 * (totalsumdeduct_tax[0].length - 3) )) - totalsumdeduct_tax[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else if(totalsumdeduct_tax[0].length < 9 && totalsumdeduct_tax[0].length >= 4){
          firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(521-(5 * (totalsumdeduct_tax[0].length - 2) )) - totalsumdeduct_tax[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
      else{
         firstPage.drawText(""+  totalsumdeduct_tax[0], { x:(521-(5 * (totalsumdeduct_tax[0].length - 1) )) - totalsumdeduct_tax[0].length ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)});
      }
       
      firstPage.drawText("."+ totalsumdeduct_tax[1],{ x: 526  ,y: 259,size: 10,font: customFont, color: rgb(0, 0, 0)}); 


        const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
        document.getElementById('pdf').src = pdfDataUri;
      },  
         thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    }
  },
  
};
</script>

